var map = {
	"./de/mecha-btn.png": "qfRj",
	"./en/mecha-btn.png": "6Gie",
	"./es/mecha-btn.png": "WPFA",
	"./fr/mecha-btn.png": "MIyB",
	"./ja/mecha-btn.png": "5Z70",
	"./ko/mecha-btn.png": "D4UV",
	"./pt/mecha-btn.png": "uTty",
	"./ru/mecha-btn.png": "FK50",
	"./tc/mecha-btn.png": "EzMU",
	"./th/mecha-btn.png": "JpoC"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "irFN";